import axiosInstance from "@/services/axiosInterceptor";

export async function getAllCountriesDetails() {
  try {
    const response = await axiosInstance.get(`https://api.countrystatecity.in/v1/countries`, {
      headers: {
        "X-CSCAPI-KEY": "bE1EbUNXRnhLNGYySFpBcGhZcEJKM0xtdk0xQldERDhCaWw5clYyRA==",
      },
    });
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
